// 31f00f9403751c9634d984ded2c01f84f6e47943|name=MetricResultRowsPage|schemaHash=008063657164fd035a1eba65a90d9c55f76456d8|kind=parser-js

export function parseMetricResultRowsPageFromJSON(
  _data,
) {
  return _data;
}

export function parseMetricResultRowsPageToJSON(
  _data,
) {
  return _data;
}
